var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame2147207312(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3432_9771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.91016 4.46875V13H3.7793V4.46875H4.91016ZM14.2793 4.46875V13H13.1426L8.84766 6.41992V13H7.7168V4.46875H8.84766L13.1602 11.0664V4.46875H14.2793Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.70703 14.1719H15.2871V14.7578H2.70703V14.1719Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("a", {
    href: "http://tiktok.com/@asra.immigration"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "black",
    fillOpacity: 0,
    x: 2.70703,
    y: 1.96875,
    width: 12.5801,
    height: 14.0625
  })), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3432_9771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4102 7.41406C12.1398 7.93535 13.0336 8.24207 13.999 8.24207V6.38543C13.8163 6.3855 13.6341 6.36644 13.4553 6.32855V7.79C12.49 7.79 11.5963 7.48332 10.8666 6.96207V10.751C10.8666 12.6464 9.32922 14.1828 7.43297 14.1828C6.72543 14.1828 6.06777 13.969 5.52148 13.6023C6.145 14.2396 7.01453 14.6348 7.97648 14.6348C9.87289 14.6348 11.4103 13.0984 11.4103 11.2029V7.41406H11.4102ZM12.0809 5.54094C11.708 5.13379 11.4632 4.60762 11.4102 4.0259V3.78711H10.895C11.0247 4.52645 11.4671 5.15809 12.0809 5.54094ZM6.72086 12.1479C6.51251 11.8749 6.3999 11.5409 6.40043 11.1975C6.40043 10.3306 7.10359 9.62773 7.97113 9.62773C8.13278 9.62765 8.29348 9.65245 8.44758 9.70129V7.80312C8.2675 7.77848 8.08578 7.76797 7.90414 7.77184V9.24926C7.74997 9.20041 7.58919 9.17562 7.42746 9.17574C6.55996 9.17574 5.85684 9.87855 5.85684 10.7455C5.85684 11.3586 6.20828 11.8893 6.72086 12.1479Z",
    fill: "#FF004F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8666 6.96203C11.5964 7.48328 12.4901 7.78996 13.4554 7.78996V6.32852C12.9166 6.21379 12.4396 5.93238 12.0809 5.54094C11.4671 5.15805 11.0248 4.52641 10.8951 3.78711H9.54184V11.2029C9.53875 12.0674 8.8368 12.7674 7.97113 12.7674C7.46105 12.7674 7.00785 12.5244 6.72086 12.1479C6.20836 11.8893 5.85688 11.3586 5.85688 10.7456C5.85688 9.87867 6.56 9.17578 7.4275 9.17578C7.59371 9.17578 7.75391 9.20164 7.90418 9.2493V7.77188C6.04121 7.81035 4.54297 9.33176 4.54297 11.2029C4.54297 12.137 4.91605 12.9837 5.5216 13.6024C6.06789 13.969 6.72551 14.1829 7.43309 14.1829C9.32937 14.1829 10.8667 12.6464 10.8667 10.751L10.8666 6.96203Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4561 6.3293V5.93422C12.9702 5.93492 12.4939 5.79892 12.0816 5.54176C12.4465 5.94106 12.927 6.21642 13.4561 6.32938M10.8957 3.78789C10.8834 3.71725 10.8739 3.64614 10.8673 3.57473V3.33594H8.99875V10.7518C8.99578 11.6162 8.29383 12.3162 7.42813 12.3162C7.18271 12.3166 6.94064 12.2592 6.72148 12.1488C7.00848 12.5252 7.46168 12.7682 7.97176 12.7682C8.83738 12.7682 9.53941 12.0682 9.54246 11.2037V3.78793L10.8957 3.78789ZM7.90492 7.77266V7.35199C7.74878 7.33068 7.59138 7.32 7.43379 7.32004C5.5373 7.32004 4 8.85652 4 10.7518C4 11.94 4.60418 12.9872 5.5223 13.6032C4.91676 12.9845 4.54367 12.1377 4.54367 11.2037C4.54367 9.33258 6.04188 7.81113 7.90492 7.77266Z",
    fill: "#00F2EA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3432_9771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3432_9771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 11.3281,
    fill: "white",
    transform: "translate(4 3.33594)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2147207312);
export default __webpack_public_path__ + "static/media/Frame 2147207312.bc9e35acb78011bb633c166496c8cc24.svg";
export { ForwardRef as ReactComponent };